import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
    name: 'user',
    initialState: {
        userData: JSON.parse(localStorage.getItem('userData')) || null,
        cartdata: JSON.parse(localStorage.getItem('cart')) || null,
        CustomerData: JSON.parse(localStorage.getItem('customerDatas')) || null,
        OpprId: JSON.parse(localStorage.getItem('OpprId')) || null,
        StatusSelected: JSON.parse(localStorage.getItem('StatusSelected')) || null,
        isCartEmpty: false,
    },
    reducers: {
        setUser: (state, action) => {
            state.userData = action.payload;
            localStorage.setItem('userData', JSON.stringify(action.payload));
        },
        logoutUser: (state, action) => { // add dispatch to the parameters
            state.userData = null;
            localStorage.removeItem('Items');
            localStorage.removeItem('userData');
            localStorage.removeItem('customerDatas');
            sessionStorage.removeItem('CRMPostData');
            localStorage.removeItem('cart');
            localStorage.removeItem('ItemGroup');
            localStorage.removeItem('OutGoingPayment');
            localStorage.removeItem('CompanyList');
            localStorage.removeItem('BranchList');
            localStorage.removeItem('successMessage');
        },
        resetUser: (state) => {
            state.userData = null;
        },
        setCart: (state, action) => {
            state.cartdata = action.payload;
            state.isCartEmpty = false;
            localStorage.setItem('cart', JSON.stringify(action.payload));
        },
        setCustomerCode: (state, action) => {
            const { customerCode, customerName, phoneNum } = action.payload;
            state.CustomerData = { customerCode, customerName, phoneNum };
            localStorage.setItem('customerDatas', JSON.stringify(state.CustomerData));
        },
        emptyCart: (state) => {
            state.cartdata = null;
            state.isCartEmpty = true;
            localStorage.removeItem('cart');
        },
        updateJwtToken: (state, action) => {
            if (state.userData) {
                state.userData.JwtToken = action.payload; // Update the JwtToken in userData
                localStorage.setItem('userData', JSON.stringify(state.userData)); // Update localStorage
            }
        },
        AddOpprId: (state, action) => {
            state.OpprId = action.payload;
            localStorage.setItem('OpprId', JSON.stringify(action.payload));
        },
        SetStatusSelected: (state, action) => {
            state.StatusSelected = action.payload;
            localStorage.setItem('StatusSelected', JSON.stringify(action.payload));
        },
        updateQuantity: (state, action) => {
            const { itemCode, newQuantity } = action.payload;
            if (state.cartdata.hasOwnProperty(itemCode)) {
                // Parse the new quantity as an integer
                const parsedQuantity = parseInt(newQuantity, 10);

                // Check if the new quantity is a number and greater than zero
                // if (!isNaN(parsedQuantity) && parsedQuantity > 0) {
                //     state.cartdata[itemCode].quantity = parsedQuantity;

                if (!isNaN(parsedQuantity) && parsedQuantity > 0) {
                    state.cartdata[itemCode].quantity = parsedQuantity;
                } else if (newQuantity === "") {
                    // If the new quantity is an empty string, set the quantity to 1
                    state.cartdata[itemCode].quantity = 1;
                } else {
                    // If the new quantity is not a number or not greater than zero, remove the item from the cart
                    delete state.cartdata[itemCode];
                    // state.cartdata[itemCode].itemCode = "";
                    // state.cartdata[itemCode].itemName = "";
                    // state.cartdata[itemCode].quantity = 0;
                }
                localStorage.setItem('cart', JSON.stringify(state.cartdata));
            } else {
                console.error(`Item with code ${itemCode} not found in cartdata`);
            }
        },
    },
});

export const { setUser, logoutUser, resetUser, setCart, emptyCart,
    setCustomerCode, updateQuantity, updateJwtToken, AddOpprId, SetStatusSelected } = userSlice.actions;
export const selectUser = (state) => state.user.userData;
export const selectCart = (state) => state.user.cartdata;
export const selectCustomer = (state) => state.user.CustomerData;
export const selectOpprID = (state) => state.user.OpprId;
export const selectStatus = (state) => state.user.StatusSelected;
export const selectIsCartEmpty = (state) => state.user.isCartEmpty;
export default userSlice.reducer;
